// extracted by mini-css-extract-plugin
export default {"wrapper":"XT-z","availablePromoMessagesLabel":"YT-z","promoMessageList":"ZT-z","promoMessage":"_T-z","appliedPromoMessage":"aU-z","promoMessageAmount":"bU-z"};